@if (isCustomerSupport || isBrokerAdmin || isContentAdmin) {
  <div class="wholepage">
    <div class="itemgroup">
      <div class="item" (click)="helpClicked()">
        <mat-icon>help_center</mat-icon>
        <div class="itemright">
          <span class="header">Help Center</span>
          <span class="description">Consult the online help, chat with a support specialist, or report a problem.</span>
        </div>
      </div>
    </div>
    @if (!currentWellspace || (!teams || teams?.length === 0)) {
      <div>
        <p>No Team found!</p>
      </div>
    }
    <!--
    <div class="itemgroup">
      <div class="item">
        <mat-icon>movie</mat-icon>
        <div class="itemright">
          <span class="header">Getting Started</span>
          <span *ngIf="!videoUrl" class="description" id="video-player"></span>
          <video *ngIf="videoUrl" class="video" [poster]="posterUrl" preload="auto" controls >
            <source [src]="videoUrl">
          </video>
        </div>
      </div>
    </div>-->
  </div>
}
@if (isPayrollAdmin) {
  <div>
    <app-payroll-dashboard class="wholepage"></app-payroll-dashboard>
  </div>
}
@if (!isCustomerSupport && !isBrokerAdmin && !isContentAdmin && !isPayrollAdmin) {
  <div class="wholepage">
    @if (showPendingAchMsg) {
      <div class="warningbox">
        <span class="description">
          <strong>Pending ACH: </strong> A transfer is in progress at the moment. To ensure the integrity of the operation,
          it is not possible to make further changes at this time. Please wait until the transfer is completed to proceed with your actions.
        </span>
      </div>
    }
    @if (homeTeamContextReady && showHomeWellspaceSelector) {
      <section class="wellspace-selection-panel">
        <div class="wellspace-selection-summary">
          <span class="wellspace-selection-eyebrow">{{isNativeTeamContextActive ? 'Current Team' : 'Current Wellspace'}}</span>
          <h2>{{currentWellspace?.name || (isNativeTeamContextActive ? 'Select a Team' : 'Select a Wellspace')}}</h2>
          @if (currentWellspace) {
            <p>
              {{currentWellspace.role ? 'Admin access' : 'Owner access'}}
              @if (currentWellspace.companyName) {
                <span> in {{currentWellspace.companyName}}</span>
              }
              @if (currentWellspace.plan) {
                <span> · {{currentWellspace.plan}} plan</span>
              }
            </p>
          }
          @if (!currentWellspace && !isNativeTeamContextActive) {
            <p>Choose a wellspace to manage members, benefits, analytics, and billing.</p>
          }
          @if (!currentWellspace && isNativeTeamContextActive && teams.length > 0) {
            <p>Select a Team to manage members, benefits, analytics, and billing.</p>
          }
          @if (isNativeTeamContextActive && teams.length === 0) {
            <p>No Teams are available for this company.</p>
          }
        </div>
        <div class="wellspace-selection-controls">
          @if (teams.length > 0) {
            <mat-form-field appearance="outline">
              <mat-label>{{isNativeTeamContextActive ? 'Switch Team' : 'Switch Wellspace'}}</mat-label>
              <mat-select [(value)]="selectedWellspaceId" (selectionChange)="switchWellspace($event.value)">
                @for (team of teams; track team) {
                  <mat-option [value]="team.id">{{team.name}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          }
          @if (!isNativeTeamContextActive && teamAdminWellspaceCreationEnabled) {
            <button mat-stroked-button color="primary" type="button" (click)="addTeam()">
              <mat-icon>add</mat-icon>
              Add Wellspace
            </button>
          }
          @if (isNativeTeamContextActive && teams.length === 0) {
            <button mat-stroked-button color="primary" type="button" (click)="openTeamsClicked()">
              <mat-icon>groups</mat-icon>
              View Teams
            </button>
          }
        </div>
      </section>
    }
    <div class="itemgroup">
      <div class="item" (click)="settingsClicked()">
        <mat-icon>person</mat-icon>
        <div class="itemright">
          <span class="header">Account Profile</span>
          <span class="description">Edit your profile, update your username and password, and manage account settings.</span>
        </div>
      </div>
    </div>
    @if (currentWellspace) {
      <div class="itemgroup">
        <!--
        <div class="item"  (click)="manageAccountsClicked()">
          <mat-icon>manage_accounts</mat-icon>
          <div class="itemright">
            <span class="header">Settings & Permissions</span>
            <span class="description">Manage your wellspace settings, permissions and preferences.</span>
          </div>
        </div>
        -->
        <div class="item" (click)="manageWellspaceClicked()">
          <mat-icon>groups</mat-icon>
          <div class="itemright">
            <span class="header">{{teamManagerWorkspace.useNativeNavigation ? 'My Team' : (isNativeTeamContextActive ? 'Manage Team' : 'Manage Your Wellspace')}}</span>
            @if (isNativeTeamContextActive) {
              <span class="description">View Team details, manage members, benefits, rewards, and allowance settings.</span>
            }
            @if (!isNativeTeamContextActive) {
              <span class="description">Invite new members, manage your benefit categories and your allowance amount.</span>
            }
          </div>
        </div>
        <div class="item" (click)="analyticsClicked()">
          <mat-icon>insights</mat-icon>
          <div class="itemright">
            <span class="header">Analytics</span>
            <span class="description">View stats for your {{isNativeTeamContextActive ? 'Team' : 'wellspace'}}, including member activity and reimbursements.</span>
          </div>
        </div>
        @if (!currentWellspace.role) {
          <div class="item" (click)="billingClicked()">
            <mat-icon>credit_card</mat-icon>
            <div class="itemright">
              <span class="header">Billing</span>
              <div>
                <span class="description">Your {{isNativeTeamContextActive ? 'Team' : 'wellspace'}} is on the</span>&nbsp;<span style="font-weight: bold" class="description">{{currentWellspace.plan}}</span>&nbsp;<span class="description">plan.</span>
                @if (!currentWellspace.approved) {
                  <span  class="description">Your {{isNativeTeamContextActive ? 'Team' : 'wellspace'}} is awaiting approval by Wallit.</span>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    @if (homeTeamContextReady && !currentWellspace) {
      <div class="itemgroup">
        @if (!isNativeTeamContextActive) {
          @for (team of teams; track team) {
            <div class="item" (click)="selectTeam(team)">
              <mat-icon>grid_view</mat-icon>
              <div class="itemright">
                <span class="header">{{team.name}}</span>
                <span class="description">Manage this team</span>
              </div>
            </div>
          }
          <div class="item" (click)="addTeam()">
            <mat-icon>add</mat-icon>
            <div class="itemright">
              <span class="header">Add a Wellspace</span>
              <span class="description">Add a new wellspace and invite members.</span>
            </div>
          </div>
        }
        @if (isNativeTeamContextActive) {
          <div class="item" (click)="openTeamsClicked()">
            <mat-icon>groups</mat-icon>
            <div class="itemright">
              <span class="header">Team</span>
              <span class="description">View the Teams available for this company.</span>
            </div>
          </div>
        }
      </div>
    }
    @if (homeTeamContextReady && (companyOffersAccess.state$ | async)?.status === 'disabled') {
      <div class="itemgroup">
        <a
          class="item external-link"
          href="https://joinmighty.com/"
          rel="external noopener noreferrer"
          target="_blank"
          >
          <mat-icon>business_center</mat-icon>
          <div class="itemright">
            <span class="header">Try Mighty Business Benefits</span>
            <span class="description">Explore benefits options for your business.</span>
          </div>
          <mat-icon class="external-link-icon">open_in_new</mat-icon>
        </a>
      </div>
    }
  </div>
}
